import { forwardRef, useImperativeHandle, useState } from 'react';
import { Flex, FormLabel, Input } from '@chakra-ui/react';
import { LoginModal } from 'src/components/organisms';
import { useAuth } from 'src/utils/auth';
import useRequest from 'src/utils/hooks/useRequest';

interface EmailCollectorProps {
  email: string;
  setEmail: (email: string) => void;
  showLabel?: boolean;
}

export interface EmailCollectorRef {
  openModal: () => void;
  isExistingEmail: () => boolean;
}

const EmailCollector = forwardRef<EmailCollectorRef, EmailCollectorProps>(
  ({ email, setEmail, showLabel = true }, ref) => {
    const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
    const [isExistingEmail, setIsExistingEmail] = useState<boolean>(false);
    const { isAuthenticated, authLoading } = useAuth();
    const { api } = useRequest();

    useImperativeHandle(ref, () => ({
      openModal: () => {
        if (isExistingEmail) {
          setIsModalOpen(true);
        }
      },
      isExistingEmail: () => isExistingEmail,
    }));

    const checkEmail = async () => {
      if (email !== '') {
        try {
          const response = await api.users.checkEmail(email);
          setIsExistingEmail(response.exists);
          setIsModalOpen(response.exists);
        } catch (error) {
          console.error('Error checking email:', error);
        }
      }
    };

    return (
      <>
        {!authLoading && !isAuthenticated ? (
          <Flex direction="column" mb={8}>
            {showLabel && <FormLabel>Email</FormLabel>}
            <Input
              type="email"
              name="email"
              placeholder="Enter your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              onBlur={checkEmail}
              required
            />
          </Flex>
        ) : null}
        <LoginModal
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          email={email}
          showSignupForm={false}
          loginFormText="It looks like you already have an account with that email address. Log in to proceed."
        />
      </>
    );
  },
);

EmailCollector.displayName = 'EmailCollector';

export default EmailCollector;
